export default {
  name: '试卷',
  permissionsKey:"JG-SJ",
  icon: 'el-icon-s-claim',
  children:{
    testPaperManage:{
      name: '试卷列表',
      permissionsKey:"JG-SJ-SJLB",
      path: '/test_paper_manage',
    }
  }
}
